import { makeStyles, Theme } from "@material-ui/core/styles";


export const useStyles = makeStyles((theme: Theme) => ({
    cameraDiv: {
        backgroundColor: theme.palette.primary.light,
        bottom: 0,
        display: "flex",
        opacity: 0.8,
        padding: "0.2em",
        position: "absolute",
        width: "100%",
    },
    cameraName: {
        paddingLeft: "0.5em",
        display: "flex",
        fontWeight: "bold",
        color: theme.palette.primary.contrastText,
        fontSize: "small",
    },
    media: {
        maxHeight: 90,
    },
    root: {
        position: "relative",
        borderRadius: 0,
    },
}));
